import React, { ReactNode } from 'react';

interface IOSHeaderProps {
  left?: ReactNode;
  center?: ReactNode;
  right?: ReactNode;
  isEmbedded?: boolean;
}

/**
 * iOS 风格的顶部导航栏容器组件
 * 提供左中右三栏布局，适配 iOS 安全区域
 */
export const IOSHeader: React.FC<IOSHeaderProps> = ({
  left,
  center,
  right,
  isEmbedded = false
}) => {
  const hasCenter = center !== null && center !== undefined;

  return (
    <div className={`${isEmbedded ? '' : 'fixed left-0 right-0'} pt-[0.35rem] top-0 z-40 flex items-center justify-between px-4 py-2 bg-white/80 dark:bg-ios-dark-gray6/80 backdrop-blur-ios border-b border-ios-gray5 dark:border-ios-dark-gray5 pt-[env(safe-area-inset-top)]`}>
      <div className={`flex-shrink-0 min-w-[3.75rem] ${hasCenter ? 'w-[20%] max-w-[5rem]' : 'flex-1'}`}>
        {left}
      </div>

      {hasCenter && (
        <div className="flex-1 flex justify-center px-1 mx-1 min-w-0">
          {center}
        </div>
      )}

      <div className="flex items-center space-x-1 flex-shrink-0 min-w-[3.75rem] w-[20%] max-w-[5rem] justify-end">
        {right}
      </div>
    </div>
  );
};
